














import Vue from "vue";

export default Vue.extend({
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    value: {
      type: [Boolean, String],
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    modelValue: {
      type: [Boolean, String],
      default: false,
    },
  },
  computed: {
    isChecked() {
      return this.modelValue == this.value;
    },
  },
});
